import HttpRequest from "@/plugins/axios";

class PageProvider extends HttpRequest {
    constructor() {
        super(process.env.VUE_APP_API_URL);
    }

    async getStudentCardPhoto({ uid, student_id, rand }) {
        const { data } = await this.get("/", {
            uid: uid,
            student_id: student_id,
            function: "get-student-card-photo",
            type: "file",
            rand: rand,
        }, {
            responseType: 'blob'
        });
        return data;
    }

    async uploadStudentCardPhoto({ uid, file }) {
        const formData = new FormData();
        formData.append("uid", uid);
        formData.append("function", "upload-student-card-photo");
        formData.append("FILE[0]", file);
        const { data } = await this.post("/", formData);
        return data;
    }


    async getDocumentType({ level_id }) {
        const { data } = await this.get("/", {
            level_id: level_id,
            function: "get-document-type",
        });
        return data;
    }

    async getDocument({ uid, student_id }) {
        const { data } = await this.get("/", {
            uid: uid,
            student_id: student_id,
            function: "get-document",
        });
        return data;
    }

    async getDocumentPages({ uid, student_id, DOCUMENT_TYPE_ID }) {
        const { data } = await this.get("/", {
            uid: uid,
            student_id: student_id,
            function: "get-document-pages",
            DOCUMENT_TYPE_ID: DOCUMENT_TYPE_ID,
        });
        return data;
    }

    async getDocumentFile({ uid, student_id, DOCUMENT_TYPE_ID, PAGE }) {
        const { data } = await this.get("/", {
            uid: uid,
            student_id: student_id,
            function: "get-document-file",
            type: "file",
            DOCUMENT_TYPE_ID: DOCUMENT_TYPE_ID,
            PAGE: PAGE
        }, {
            responseType: 'blob'
        });
        return data;
    }

    async uploadDocument({ uid, DOCUMENT_TYPE_ID, files }) {
        const formData = new FormData();
        formData.append("uid", uid);
        formData.append("function", "upload-document-file");
        formData.append("DOCUMENT_TYPE_ID", DOCUMENT_TYPE_ID);
        files.forEach((file, index) => {
            formData.append(`FILE[${index}]`, file);
        });
        const { data } = await this.post("/", formData);
        return data;
    }

    async commentDocumentFile({ uid, DOCUMENT_TYPE_ID, UPLOAD_STATUS_ID, COMMENT }) {
        const { data } = await this.update("/", {
            function: "comment-document-file",
            uid: uid,
            DOCUMENT_TYPE_ID: DOCUMENT_TYPE_ID,
            UPLOAD_STATUS_ID: UPLOAD_STATUS_ID,
            COMMENT: COMMENT,
        });
        return data;
    }

    async deleteDocumentFile({ uid, DOCUMENT_TYPE_ID }) {
        const { data } = await this.delete("/", {
            uid: uid,
            function: "delete-document-file",
            DOCUMENT_TYPE_ID: DOCUMENT_TYPE_ID,
        });
        return data;
    }
}

export default PageProvider;
